import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { SupplierContact, Supplier } from '@common/models';

@Injectable({ providedIn: 'root' })
export class SupplierContactService{
    /**
     * 
     * @param {HttpClient} _http 
     */
    constructor(private _http: HttpClient) {} 

    /**
     * Funcion que devuelve el listado de contactos de un proveedor
     * @param id Entero que identifica el proveedor
     * @returns  devuelve listado de contactos de un proveedor
     */
    getBySupplierId(id:number){
        return this._http.get<SupplierContact[]>(`${environment.commonApiUrl}/api/supplier-contact/${id}`);
    }

    /**
     * Funcion que elimina un contacto de un determinado proveedor
     * @param idSupplier  Entero que identifica al proveedor
     * @param idContact Entero que identifica al contacto
     * @returns devuelve un entity response
     */
    deleteSupplierContact(idSupplier:number,idContact:number){
        return this._http.delete<SupplierContact>(`${environment.commonApiUrl}/api/supplier-contact/${idSupplier}/${idContact}`).pipe(
          map((response: any) => response.supplier as Supplier),
          catchError(e => {
            return throwError(e);
          })
        );
      }

      addSupplierContact(suppplierContact){
        return this._http.post<SupplierContact>(`${environment.commonApiUrl}/api/supplier-contact`, suppplierContact).pipe(
          map((response: any) => response.supplier as Supplier),
          catchError(e => {
            return throwError(e);
          })
        );
      }

      editSupplier(supplier: Supplier) {
        return this._http.put<Supplier>(`${environment.commonApiUrl}/api/supplier-contact/${supplier.id}`,supplier).pipe(
          map((response: any) => response.supplier as Supplier),
          catchError(e => {
            return throwError(e);
          })
        );
      }
}
